export enum OttopilotBtlActivitiesWorkspaceCapabilityAccessOperation {
    create = "21d464b5-9ddc-46d5-9997-3ff35a78eeec",
    read = "771d8a24-f04b-4786-a9b6-94c490fbf6ed",
    update = "5281e728-ff0b-42ab-9afa-9f4d01061f65",
    delete = "eb6f2be8-8a24-455d-836b-638f57cb6b05",
}
